// @ts-check
import React from 'react';
import PropTypes from 'prop-types';

import BusComponent from '../BusComponent';
import TextInput from '../form/TextInput';

const SEARCH_TIMEOUT = 500;
const SEARCH_THRESHOLD = 3; // the minimum number of characters for search to initiate

/**
 * Free-text input with HERE address suggestions. Typing stays free-form;
 * picking a suggestion hands its coordinates to the parent via onSelect.
 */
class LocationSuggestionInput extends BusComponent {
    constructor(props, context) {
        super(props, context);
        this.state = {
            suggestions: [],
        };
    }

    componentDidMount() {
        this.bindGluBusEvents({
            GEOCODE_SEARCH_RESPONSE: this.onSuggestionsResponse,
        });
        document.addEventListener('mousedown', this.onDocumentMouseDown);
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
        clearTimeout(this.searchTimeout);
        document.removeEventListener('mousedown', this.onDocumentMouseDown);
    }

    onDocumentMouseDown = e => {
        if (this.container && !this.container.contains(e.target)) {
            this.setState({ suggestions: [] });
        }
    };

    onSuggestionsResponse = ({ query, data }) => {
        // stale response — the input has moved on
        if (query !== this.props.value) return;
        this.setState({
            suggestions: data.filter(item => item.administrativeAreaType !== 'state'),
        });
    };

    onChange = value => {
        this.props.onChange(value);
        clearTimeout(this.searchTimeout);
        if (!value || value.trim().length < SEARCH_THRESHOLD) {
            this.setState({ suggestions: [] });
            return;
        }
        this.searchTimeout = setTimeout(() => {
            this.emit('GEOCODE_SEARCH_REQUEST', { query: this.props.value });
        }, SEARCH_TIMEOUT);
    };

    onSuggestionClick = item => {
        this.setState({ suggestions: [] });
        this.props.onSelect({
            lat: item.position.lat,
            lng: item.position.lng,
            label: item.title,
        });
    };

    render() {
        const { suggestions } = this.state;
        return (
            <div
                className="location-suggestion-input"
                ref={c => {
                    this.container = c;
                }}
            >
                <TextInput
                    placeholder={this.props.placeholder}
                    value={this.props.value}
                    onChange={this.onChange}
                />
                {suggestions.length > 0 && (
                    <ul className="location-suggestion-input__list">
                        {suggestions.map(item => (
                            <li key={item.id}>
                                <button
                                    type="button"
                                    title={item.title}
                                    onClick={() => this.onSuggestionClick(item)}
                                >
                                    {item.title}
                                </button>
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        );
    }
}

LocationSuggestionInput.propTypes = {
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
};

LocationSuggestionInput.defaultProps = {
    placeholder: '',
};

export default LocationSuggestionInput;
